import React, { useContext, useState } from "react";
import { useMutation } from "@apollo/client";
//Import from project
import { AuthContext } from "../../Context/AuthContext";
import { DELETE_GROUP_FEE } from "../../Schema/GroupFee";

const useDeleteGroupFee = ({ handleClose, setRefetch, id }) => {
  // Change Language
  const { setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const [deleteGroupFee] = useMutation(DELETE_GROUP_FEE, {
    onCompleted: ({ deleteGroupFee }) => {
      setLoading(false);
      if (deleteGroupFee?.isSuccess === true) {
        setAlert(true, "success", deleteGroupFee?.message);
        handleClose();
        setRefetch();
      } else {
        setAlert(true, "error", deleteGroupFee?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const handleDelete = () => {
    setLoading(true);
    deleteGroupFee({
      variables: {
        id: id,
      },
    });
  };

  return { loading, handleDelete };
};

export default useDeleteGroupFee;
